import React, { useEffect } from 'react';
import { Header } from '../components/Header';
import { Footer } from '../components/Footer';
import { PermisHero } from '../components/permis/PermisHero';
import { PermisChallenge } from '../components/permis/PermisChallenge';
import { PermisSolution } from '../components/permis/PermisSolution';
import { PermisAnalytics } from '../components/permis/PermisAnalytics';
import { PermisFinalCTA } from '../components/permis/PermisFinalCTA';
import { trackEvent } from '../utils/analytics';
export function Permis() {
  useEffect(() => {
    trackEvent('Page Viewed', {
      page: 'Permis'
    });
  }, []);
  return <div className="w-full min-h-screen bg-white" data-id="element-8784" data-mp="3r5ofxt14y50">
      <Header data-id="element-8785" data-mp="3u1ihb1rb2o6" />
      <main className="pt-[120px]" data-id="element-8786" data-mp="3uyrvm0eyjiqm">
        <section className="relative pt-12 pb-16 px-6 overflow-hidden bg-[#FCFCFE]" data-id="element-8787" data-mp="3uxq82wgr93s0">
          <div className="pointer-events-none absolute -top-40 right-0 w-[700px] h-[700px] rounded-full bg-[#EEEDFD] opacity-60 blur-[150px]" aria-hidden="true" data-id="element-8788" data-mp="2ojh7q1lbujbp" />
          <PermisHero data-id="element-8789" data-mp="10zpc7p8ezm9q" />
        </section>
        <section className="py-20 lg:py-24 px-6 bg-white border-t border-[#EEF0F4] overflow-hidden" data-id="element-8790" data-mp="110s4a0hh3ur8">
          <PermisChallenge data-id="element-8791" data-mp="15xqsk2egh7hi" />
        </section>
        <section className="py-20 lg:py-24 px-6 bg-[#FCFCFE] border-t border-[#EEF0F4] overflow-hidden" data-id="element-8792" data-mp="15wfrwbgb4fum">
          <PermisSolution data-id="element-8793" data-mp="wy3thn978drm" />
        </section>
        <section className="py-20 lg:py-24 px-6 bg-white border-t border-[#EEF0F4] overflow-hidden" data-id="element-8794" data-mp="wx2dr5h8n33k">
          <PermisAnalytics data-id="element-8795" data-mp="i8frskx3vd3d" />
        </section>
        <section className="relative py-20 lg:py-24 px-6 bg-[#FCFCFE] border-t border-[#EEF0F4] overflow-hidden" data-id="element-8796" data-mp="i7ehwjrtswn8">
          <div className="pointer-events-none absolute -bottom-40 left-0 w-[700px] h-[500px] rounded-full bg-[#EEEDFD] opacity-60 blur-[150px]" aria-hidden="true" data-id="element-8797" data-mp="98t1ov9tttpm" />
          <PermisFinalCTA data-id="element-8798" data-mp="d81t3the9fi0" />
        </section>
      </main>
      <Footer data-id="element-8799" data-mp="3vfhkg3k5io1a" />
    </div>;
}